import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type DialogTypes = 'info' | 'warning' | 'error' | 'success';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: DialogTypes;
  /** Prevent the dialog from closing via Escape or backdrop click. Default: false. */
  disableClose?: boolean;
  /** Apply a blur backdrop instead of the default dark scrim. */
  blurBackdrop?: boolean;
  /** Show a spinner on the cancel button for this many ms before the dialog closes. */
  cancelLoadingDurationMs?: number;
}

export interface TypeStyling {
  type: DialogTypes;
  iconClass: string;
  iconColor: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  isCancelLoading = false;

  public typeStylingMap: Map<string, TypeStyling> = new Map([
    ['info', { type: 'info', iconClass: 'fa fa-info-circle', iconColor: '#2196f3' }],
    ['warning', { type: 'warning', iconClass: 'fa fa-exclamation-triangle', iconColor: '#ff9800' }],
    ['error', { type: 'error', iconClass: 'fa fa-times-circle', iconColor: '#f44336' }],
    ['success', { type: 'success', iconClass: 'fa fa-check-circle', iconColor: '#4caf50' }]
  ]);

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    // Set defaults
    this.data.confirmText = this.data.confirmText || 'OK';
    this.data.cancelText = this.data.cancelText || 'Cancel';
    this.data.type = this.data.type || 'info';
  }

  onCancel(): void {
    if (this.data.cancelLoadingDurationMs) {
      this.isCancelLoading = true;
      setTimeout(() => this.dialogRef.close(false), this.data.cancelLoadingDurationMs);
    } else {
      this.dialogRef.close(false);
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  getIconClass(): string {
    return this.typeStylingMap.get(this.data.type!)?.iconClass || 'fa fa-info-circle';
  }

  getIconColor(): string {
    return this.typeStylingMap.get(this.data.type!)?.iconColor || '#2196f3';
  }
}
